<template>
  <div ref="buyMediaModal" class="modal modal-v modal-v--normal fade" id="imagePaymentModal" tabindex="-1" role="dialog" aria-labelledby="imagePaymentModalLabel" aria-hidden="true">
    <div class="modal-dialog " role="document">

      <div class="modal-content">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>

        <div class="modal-body d-flex flex-column align-items-center justify-content-center">
          <h2 class="title title--medium mb-5">
            {{ trans.get('profile:show.image_buy_modal.header') }}
          </h2>
          <img v-if="media" class="profile-show__modal-avatar" :src="media.url+'?p=small'" alt="">
          <img v-else class="profile-show__modal-image mb-3" src="/img/viluu/background/coins.png" alt="coins">
          <p class="desc desc--lightgrey mb-3 text-center">
            {{ trans.get('profile:show.image_buy_modal.desc') }}
          </p>
          <div class="title title--big">
            <span v-if="media" class="js-price">{{ media.price }}</span>
            <i class="demo-icon icon-n-lova-coins"></i>
          </div>
          <button type="button" class="button button__fill mt-3 mb-3" @click="unlock">
            {{ trans.get('profile:show.image_buy_modal.unlock_button') }}
          </button>
          <div v-if="false" class="checkbox-standard pull-left">
            <label>
              <input v-model="agreement" name="agreement" type="checkbox">
              <span class="checkbox-standard__box checkbox-standard__box--small mr-2"></span>
              <span class="desc desc--small">
                {{ trans.get('profile:show.image_buy_modal.dont_show_modal_anymore') }}
              </span>
            </label>
          </div>
          <button type="button" class="button button__link button__link--underline mt-3" data-dismiss="modal">
            {{ trans.get('profile:show.image_buy_modal.close_button') }}
          </button>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { mapGetters } from 'vuex';


export default {
  name: 'BuyMediaModal',
  props: {},
  data() {
    return {
      agreement: true,
      open: false,
      media: null,
      form: {},
      profileId: null,
      avatarUrl: null,
    };
  },
  computed: {
    ...mapGetters('user', {
      user: 'getUser',
      isPaymentApproved: 'isPaymentApproved',
    }),
  },
  watch: {
    open(val) {
      if (val) {
        if (this.media.price > (this.user.coins + this.user.free_coins)) {
          this.open = false;
          this.$eventHub.$emit('EventPopupModalOpen', this.globals.actions.ACTION_NOT_ENOUGH_COINS);
          return false;
        }

        if (this.isPaymentApproved(window.globals.user.payment_approval_media)) {
          this.unlock();
        } else {
          $(this.$refs.buyMediaModal).modal('show');
        }
      } else {
        $(this.$refs.buyMediaModal).modal('hide');
        this.profileId = null;
        this.form = {};
      }
    },
  },
  methods: {
    unlock() {
      axios
        .post(zRoute('ajax.profiles.media.store'), {
          media_id: this.media.id,
          agreement: this.agreement,
        })
        .then(response => {
          this.$eventHub.$emit('FreshMedia', response.data.data);
          this.open = false;
        })
        .catch(error => {
          if (error.response.data.reason === window.globals.actions.ACTION_NOT_ENOUGH_COINS) {
            this.open = false;
          }
          if (error.response.data.reason === window.globals.actions.ACTION_PAYWALL_PAYMENT) {
            this.open = false;
          }
        });
    },
  },
  mounted() {
    let vm = this;
    $(this.$refs.buyMediaModal).on('hidden.bs.modal', function (e) {
      vm.open = false;
    });

    this.$eventHub.$on('BuyMediaModalOpen', (media) => {
      vm.open = true;
      vm.media = media;
    });
  }
};
</script>

<style scoped>

</style>
